import Constants from "../components/lib/Constants";

const initState = {
    entity: {
        time: 30,
        counter: 0,
        state: "STOP",
    }
};
const GameReducer = (state = initState, action) => {
    switch (action.type) {
        case Constants.REQUEST_START_GAME:
            return {
                entity: {
                    time: initState.entity.time,
                    counter: initState.entity.counter,
                    state: "RUN",
                }
            };
        case Constants.REQUEST_ADD_GAME_TIME:
            let counter = state.entity.counter;
            counter = counter + 1;
            let time = (state.entity.time + 30);
            return {
                entity: {
                    counter: counter,
                    time: time,
                    state: state.entity.state,
                }
            };

        case   Constants.REQUEST_UPDATE_TIMER:
            return {
                entity: {
                    time: action.payload,
                    counter: state.entity.counter,
                    state: state.entity.state,
                }
            }
        case   Constants.REQUEST_GAME_STATUS:
            return {
                entity: {
                    time: state.entity.time,
                    counter: state.entity.counter,
                    state: action.payload ? action.payload :  state.entity.state == "PAUSE" ? "RUN" : "PAUSE",
                }
            }
        default:
            return state;
    }
};
export default GameReducer;



// WEBPACK FOOTER //
// ./src/reducers/GameReducer.js